import { Action } from '@ngrx/store';

import { ApiKeysResponse } from '../../services/api-keys/api-keys.model';

export const ADD_API_KEYS = '[XENA] ADD_API_KEYS';
export const REMOVE_API_KEY = '[XENA] REMOVE_API_KEYS';


export class AddApiKeys implements Action {
	readonly type = ADD_API_KEYS;

	constructor(public payload: ApiKeysResponse) {}
}

export class RemoveApiKey implements Action {
	readonly type = REMOVE_API_KEY;

	constructor(public payload: string) {}
}

export type All
	= AddApiKeys
	| RemoveApiKey;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/api-key.ts